import * as React from 'react'

import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import teams from 'modules/teams/store/collections/teams'

interface Props {
  readonly?: boolean
  field: Field
}

const TeamGroupSelection = ({ readonly, field }: Props) => {
  const teamOptions = React.useRef(
    teams.map((team) => ({
      label: team.attributes.name,
      value: team.attributes.id,
    }))
  ).current

  return (
    <Select
      none={i18n.t('common.none')}
      readonly={readonly}
      field={field}
      options={teamOptions}
      defaultOption={null}
    />
  )
}

export default observer(TeamGroupSelection)
